import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Item from './Item';
import Summary from './Summary';
import Schedule from './Schedule';
import ScheduleDeliverable from './ScheduleDeliverable';
import DeliverableItems from './DeliverableItems';


const CategoryMain = styled.div`
							@media (max-width: 991px) {
								padding-top:100px;
								.mobile-title{
									text-align:center;
									margin-bottom:6px;
								}
							}
							.category-outer{
								background: #F5F5F5;
								padding: 20px 40px;
								margin: 20px auto;
							}
							.cat-border{
								border-top:solid 1px #dfdfdf;
								padding-top:15px;
								@media (max-width: 991px) {
									border-top:0px;
								}
							}
							.title{
								color:#000;
								font-size:14px;
							}

							.activity-filter{
								margin:auto;
								width:200px;
								padding-bottom:15px;
								line-height:35px;
								span{
									padding-right:5px;
								}
							}

							.switch {
								position: relative;
								display: inline-block;
								width: 60px;
								height: 34px;
							  }
							  
							  .switch input { 
								opacity: 0;
								width: 0;
								height: 0;
							  }
							  
							  .slider {
								position: absolute;
								cursor: pointer;
								top: 0;
								left: 0;
								right: 0;
								bottom: 0;
								background-color: #ccc;
								-webkit-transition: .4s;
								transition: .4s;
							  }
							  
							  .slider:before {
								position: absolute;
								content: "";
								height: 26px;
								width: 26px;
								left: 4px;
								bottom: 4px;
								background-color: white;
								-webkit-transition: .4s;
								transition: .4s;
							  }
							  
							  input:checked + .slider {
								background-color: #C30019;
							  }
							  
							  input:focus + .slider {
								box-shadow: 0 0 1px #C30019;
							  }
							  
							  input:checked + .slider:before {
								-webkit-transform: translateX(26px);
								-ms-transform: translateX(26px);
								transform: translateX(26px);
							  }
							  
							  /* Rounded sliders */
							  .slider.round {
								border-radius: 34px;
							  }
							  
							  .slider.round:before {
								border-radius: 50%;
							  }
							  label{
								  display:block;
								  width:30%;
								  float:left;
								  padding-top:5px;
								  font-weight:bold;
							  }
							  .form-control{
								  width:70%;
								  float:left;
								  font-weight:bold;
							  }
							
`;

const DepartmentHeader = styled.div`
                        	background: #C30019;
                        	color:#FFF;
							text-align:center;
							padding: 10px;
							width:100%;

`;

const SummaryHeader = styled.div`
                        	background: #585857;
                        	color:#FFF;
							text-align:center;
							padding: 10px;
							width:100%;

`;

const Categories = (props) => {
	const [sortOrder, setSortOrder] = useState('activity');
	const [myActivities, setMyActivities] = useState(0);
	const activities = useSelector(state => state.activities);
	const depts = useSelector(state => state.departments);
	const currentUser = useSelector(state => state.currentUser);
	const dependencies = useSelector(state => state.dependencies);
	const deliverables = useSelector(state => state.deliverables);

	let dept = depts.filter(dept => dept.slug === props.match.params.id);
	dept = dept.length > 0 ? dept[0] : {};
	let activityItems;

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);


	if (myActivities) {
		activityItems = activities.filter(activity => activity.users && (activity.users.findIndex(user => user.key === currentUser.key) !== -1));
	} else {
		activityItems = activities;
	}
	return (
		<section>
			<CategoryMain>
				<div className="container">
					<div className="row">
						<DepartmentHeader>{dept.name}</DepartmentHeader>
					</div>
					<div className="category-outer">
						<section >
							<div className="row">
								<div className="col-4">
									<label htmlFor="order1">Order by:</label>
									<select className="form-control" id="order1" onChange={event => setSortOrder(event.target.value)} defaultValue={sortOrder}>
										<option value='activity'>Work streams</option>
										<option value='deliverable'>Department deliverables</option>
									</select>
								</div>
								<div className="col-4 align-center">
									<div className="activity-filter">
										<span>My activities</span> <label className="switch">
											<input type="checkbox" defaultChecked={myActivities} onChange={event => setMyActivities(myActivities === true ? false : true)} />
											<span className="slider round"></span>
										</label>
									</div>
								</div>
							</div>
						</section>
						{sortOrder === 'activity' ?
							<div>
								{dept && dept.categories ? Object.values(dept.categories).map((category, index) => (
									activityItems.filter(activity => (activity.dept === dept.slug) && (activity.category === category.slug)).length !== 0 ?
										<section key={index}>
											<div className="row">
												<div className="col-12">
													<div className="cat-border"></div>
												</div>
											</div>
											<div className="row">
												<div className="col-sm-12 col-md-2 mobile-title">
													<span className="title">{category.name}</span>
												</div>
												<div className="col-sm-12 col-md-8 px-0">
													<div className="row">
														<div className="col-12 px-0">
															<div className="row">
																{activityItems.filter(activity => (activity.dept === dept.slug) && (activity.category === category.slug)).map((item, index) => (
																	<div className="col-sm-12 col-md-3 px-2" key={index}>
																		<Item item={item} />
																	</div>
																)
																)}
															</div>
														</div>
													</div>
												</div>
												<div className="col-sm-12 col-md-2">

												</div>
											</div>
										</section>
										: ''
								)
								) : ''}
							</div>
							: <DeliverableItems dept={dept} activityItems={activityItems} deliverables={deliverables} />}
					</div>
				</div>
			</CategoryMain>
			<div className="container">
				<div className="row show-desktop">
					<div className="col-12">
						<SummaryHeader>Schedule</SummaryHeader>
					</div>
				</div>
				{sortOrder === 'activity' ?
					<Schedule activities={activities} categories={dept && dept.categories ? Object.values(dept.categories) : []} dependencies={dependencies} />
					:
					<ScheduleDeliverable activities={activities} categories={dept && dept.categories ? Object.values(dept.categories) : []} dependencies={dependencies} deliverables={deliverables.filter(deliverable => deliverable.dept === dept.slug)} />
				}
			</div>
		</section>
	);
}

export default Categories;